import { render, staticRenderFns } from "./AdvertisingAddItem.vue?vue&type=template&id=47e96e76&scoped=true"
import script from "./AdvertisingAddItem.vue?vue&type=script&lang=js"
export * from "./AdvertisingAddItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e96e76",
  null
  
)

export default component.exports